<template>
  <div class="slider-banner product-bg">
    <!-- swiper1 -->
    <swiper class="swiper gallery-top">
      <swiper-slide>
        <div
          class="slide-image"
          :style="{
            backgroundImage: 'url(' + goodsImg + ')',
          }"
        >
          <!-- <img
            src="../assets/images/videos.png"
            class="video_play"
            v-if="videolines && index === 0"
          /> -->
        </div>
      </swiper-slide>
    </swiper>
    <!-- swiper2 Thumbs -->
    <swiper
      class="swiper gallery-thumbs"
      :options="swiperOptionThumbs"
      ref="swiperThumbs"
      v-if="imgUrls.length > 0"
    >
      <swiper-slide v-for="(item, index) in imgUrls" :key="index">
        <div
          v-on:mouseover="result(index)"
          :class="resultNum === index ? 'active' : ''"
          class="slide-image"
          v-bind:style="{ backgroundImage: 'url(' + item + ')' }"
        >
          <!-- <img
            src="../assets/images/videos.png"
            class="video_play"
            v-if="videolines && index === 0"
          /> -->
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
export default {
  name: "ProductConSwiper",
  components: {
    swiper,
    swiperSlide,
  },
  data: function () {
    return {
      videolines: this.videoline,
      isOnPlay: false,

      num: 0,
      currents: 1,
      goodsImg: this.imgUrls[0],
      swiperOptionThumbs: {
        loopedSlides: 5, // looped slides should be the same
        observeParents: true,
        observer: true,
        spaceBetween: 10,
        slidesPerView: "auto",
      },
    };
  },

  props: {
    imgUrls: {
      type: Array,
      default: () => [],
    },
    videoline: {
      type: String,
      default: () => "",
    },
    // goodsImg: {
    //   type: String,
    //   default: () => "",
    // },
  },
  watch: {
    videoline: {
      handler(newName) {
        this.videolines = newName;
      },
      deep: true,
    },
  },

  computed: {
    resultNum() {
      return this.num;
    },
  },
  mounted: function () {},
  methods: {
    result(index) {
      this.num = index;
      let i = index;
      this.goodsImg = this.imgUrls[i];
    },
  },
};
</script>
<style lang="scss" scoped>
// ::v-deep {
//   .swiper-slide {
//     width: 500px !important;
//   }
// }
</style>

<style scoped>
.videoBox {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 100%;
}
.gallery-top {
  width: 530px;
  height: 415px;
  margin-bottom: 16px;
  overflow: inherit;
  border-radius: 10px;
}
.videoBox video {
  width: 100%;
  height: 100%;
}
.video-source {
  width: 100%;
  height: 100%;
}
.video_play {
  position: absolute;
  width: 1rem;
  height: 1rem;
  left: 45%;
  top: 45%;
  z-index: 11;
}
.swiper.gallery-thumbs {
  height: 75px;
  box-sizing: border-box;
}
.swiper.gallery-thumbs .swiper-slide {
  width: 20%;
  height: 100%;
}
.swiper .swiper-slide .slide-image {
  background-size: auto;
  background-position: 50%;
  border: 2px solid #fff;
  background-repeat: no-repeat;
}
.swiper .swiper-slide .slide-image.active {
  border-color: #ff6a00;
}
.gallery-thumbs .swiper-slide .slide-image {
  background-size: 100%;
}
</style>
